import React, { Component } from "react";
import { CircularProgress } from "material-ui-next/Progress";
import { observer } from "mobx-react";
import Icon from "material-ui-next/Icon";
import { colors } from "assets";

class ImportedField extends Component {
  render() {
    const statusTree = {
      pending: {
        component: <Icon>cloud_upload</Icon>,
        color: colors.primary.dark
      },
      importing: {
        component: <CircularProgress />,
        color: null
      },
      success: {
        component: <Icon>cloud_done</Icon>,
        color: colors.secondary.normal
      },
      error: {
        component: <Icon>error</Icon>,
        color: colors.accent.normal
      }
    };

    const { stages, row } = this.props;
    const stage = stages[row.uuid];
    const status = statusTree[stage] || statusTree.pending;

    return (
      <div style={{ textAlign: "center", color: status.color }}>
        {status.component}
      </div>
    );
  }
}

export default observer(ImportedField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/imported.js